import { createI18n } from 'vue-i18n'
import enUS from './langs/en'
import zhCN from './langs/zhCN'
import zhTW from './langs/zhTW'

// dayjs
import dayjs from 'dayjs'
import 'dayjs/locale/zh-cn'
import 'dayjs/locale/en'

// 1. 获取初始语言（优先 localStorage，否则默认 en-US）
const initialLang = localStorage.getItem('language') || 'zh-CN'

// 2. 创建 i18n 实例
const i18n = createI18n({
  locale: initialLang,
  fallbackLocale: 'zh-CN', // 建议 fallback 与默认语言一致，或设为 'zh-CN' 但需确保 messages 有对应
  legacy: false,
  globalInjection: true,
  messages: {
    'en-US': enUS,
    'zh-CN': zhCN,
	'zh-TW': zhTW
  }
})

// 3. 同步设置 dayjs 语言
const setDayjsLocale = (lang) => {
  // 将 i18n 的语言 key 映射为 dayjs 的 locale key
  const dayjsLangMap = {
    'en-US': 'en',
    'zh-CN': 'zh-cn'
  }
  const dayjsLang = dayjsLangMap[lang] || 'en'
  dayjs.locale(dayjsLang)
}

// 初始化 dayjs 语言
setDayjsLocale(initialLang)

// 4. 语言切换函数
export function changeLanguage(lang) {
  i18n.global.locale.value = lang
  localStorage.setItem('language', lang)
  setDayjsLocale(lang) //同步更新 dayjs 语言
}

export { i18n }